// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";
import { TouchCardKind } from "../touchCard/common/data/TouchCardKind";

const {ccclass, property} = cc._decorator;

const c_adCount = 3;
@ccclass
export default class SkipPlotConfirmLayer extends BasePopUpLayer {

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    @property(cc.Label)
    labelAdCount: cc.Label = null;

    start () {
        this.refreshCount();
    }

    refreshCount() {
        let gameData = NormalGameManager._instance.getGameData();
        this.labelAdCount.string = gameData.skipPlotAdCount + '/' + c_adCount;
        if (gameData.skipPlotAdCount >= c_adCount) {
            this.skipPlot();
        }
    }

    onClickAd() {
        let gameData = NormalGameManager._instance.getGameData();
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            gameData.skipPlotAdCount++;
            NormalGameManager._instance.writeGameData();
            this.refreshCount();
        },()=>{

        },null,"看广告跳剧情");
    }
   
    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    skipPlot() {
        
        let gameData = NormalGameManager._instance.getGameData();
        let goodsList = [GeneralKind.PropId.CUPID_ARROW_ID, 50016, 50045];

        // 给物品
        for (let o of goodsList) {
            NormalGameManager._instance.onPushGoods(o, 1);
        }

        gameData.bFinishHelpWife = true;
        gameData.bFinishHitRob = true;
        gameData.bFinishHitRobEvent = true;
        gameData.bOpenHitRobEvent = true;
        gameData.bEnterYabiao1 = true;
        gameData.bEnterYabiao2 = true;
        gameData.bEnterBoastGuiFei = true;
        gameData.bFinishBoastGuiFei = true;
        gameData.firstPassDartFlag = false;
        gameData.bFirstFinishYabiao1 = true;
        gameData.isDeliveryWings = true;
        gameData.isJoinTakeCow = true;
        gameData.agreeTakeCow = true;
        gameData.agreeCupidHelp2 = true;
        gameData.bShowKongTongBtn = true;
        gameData.saveArcheryFlag = true;
        gameData.saveCupidFlag = true;
        gameData.isFirstLiBai = false;
        gameData.liBaiGoodValue = 100;

        gameData.wechatRecordPoint.push('5034Finish');
        gameData.wechatRecordPoint.push('5040Finish');
        gameData.wechatRecordPoint.push('5035Finish');
        gameData.wechatRecordPoint.push('5036Finish');

        let list = TouchCardKind.ItemList;
        for (let i = 0; i < list.length; i++) {
            let o = list[i];
            gameData.touchCardLevelLock[o.idx] = true;
        }
        gameData.firstEnterLayer.push(UIKind.UILayerTag.PalaceLayer);
        gameData.firstEnterLayer.push(UIKind.UILayerTag.BLM);

        // let officialLv = gameData.m_officialLv;
        let m_reputation = gameData.m_reputation;
        let exp = this.getLvExp(4);
        if (!isNaN(exp)) {
            exp -= m_reputation;
            if (exp > 0) {
                NormalGameManager._instance.addExp(exp);
            }
        } else {
            console.error('经验 数据错误');
        }
        NormalGameManager._instance.writeGameData();

        this.destroyNode();
        this._carryData.parent.finishSkip();

        NormalGameManager._instance.taskDataManage.dataCompatibility();
    }

    getLvExp(lv: number) {
        let maxLv = CsvDataManage.instance.getMaxLv();
        let clv = Math.min(lv, maxLv);
        let info = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEVEL, clv);
        if (!info) {
            return 0;
        }
        let exp = info.exp.replace(/,/g, '');
        return Number(exp);
    }

    // update (dt) {}
}
